import { getTag } from "./get-tag.js";
const createTagEntry = (tag, titlesMap, getTagId, children, isGroup = false) => {
  const id = getTagId(tag);
  const title = tag["x-displayName"] ?? tag.name ?? "Untitled Tag";
  titlesMap.set(id, title);
  return {
    id,
    title,
    name: tag.name || title,
    children,
    isGroup,
    type: "tag"
  };
};
const getSortedTagEntries = (_keys, tagsMap, titlesMap, { getTagId, tagsSorter, operationsSorter }) => {
  const hasDefault = _keys.includes("default");
  const keys = hasDefault ? _keys.filter((key) => key !== "default") : _keys;
  if (tagsSorter === "alpha") {
    keys.sort((a, b) => {
      const nameA = getTag(tagsMap, a).tag["x-displayName"] || a || "Untitled Tag";
      const nameB = getTag(tagsMap, b).tag["x-displayName"] || b || "Untitled Tag";
      return nameA.localeCompare(nameB);
    });
  } else if (typeof tagsSorter === "function") {
    keys.sort((a, b) => tagsSorter(getTag(tagsMap, a).tag, getTag(tagsMap, b).tag));
  }
  if (hasDefault) {
    keys.push("default");
  }
  return keys.flatMap((key) => {
    const { tag, entries } = getTag(tagsMap, key);
    if (tag["x-internal"] || tag["x-scalar-ignore"]) {
      return [];
    }
    if (operationsSorter === "alpha") {
      entries.sort((a, b) => "method" in a && "method" in b ? a.title.localeCompare(b.title) : 0);
    } else if (operationsSorter === "method") {
      entries.sort((a, b) => "method" in a && "method" in b ? a.method.localeCompare(b.method) : 0);
    } else if (typeof operationsSorter === "function") {
      entries.sort((a, b) => {
        if (a.type !== "operation" && a.type !== "webhook" || b.type !== "operation" && b.type !== "webhook") {
          return 0;
        }
        const pathA = a.type === "operation" ? a.path : a.name;
        const pathB = b.type === "operation" ? b.path : b.name;
        return operationsSorter(
          { method: a.method, path: pathA, ref: a.ref, httpVerb: a.method },
          { method: b.method, path: pathB, ref: b.ref, httpVerb: b.method }
        );
      });
    }
    return entries.length ? createTagEntry(tag, titlesMap, getTagId, entries) : [];
  });
};
const traverseTags = (content, tagsMap, titlesMap, { getTagId, tagsSorter, operationsSorter }) => {
  if (content["x-tagGroups"]) {
    const tagGroups = content["x-tagGroups"];
    return tagGroups.flatMap((tagGroup) => {
      const entries = getSortedTagEntries(tagGroup.tags ?? [], tagsMap, titlesMap, {
        getTagId,
        tagsSorter,
        operationsSorter
      });
      return entries.length ? createTagEntry(tagGroup, titlesMap, getTagId, entries, true) : [];
    });
  }
  const keys = Array.from(tagsMap.keys());
  const tags = getSortedTagEntries(keys, tagsMap, titlesMap, { getTagId, tagsSorter, operationsSorter });
  if (tags.length === 1 && tags[0]?.title === "default") {
    return tags[0]?.children ?? [];
  }
  return tags;
};
export {
  traverseTags
};
//# sourceMappingURL=traverse-tags.js.map
